import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';

import Loading from '../../Loading';
import WarningPanel from '../../WarningPanel';

const NumberOfAppointments = ({ userId, reloadBoxes }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        count_all_appointments: '',
        count_all_submissions: '',
    });
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        setLoading(true);

        axios.get(`/api/get-number-appointments?id=${userId}`)
        .then((response) => {
            setWarning('');
            setFormInfo(response.data);
        })
        .catch((error) => {
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        });
    }, [userId, reloadBoxes, reload]);


    return (
        <>
            <div className={`boxPage`}>
                <div className='boxHeader'>
                    <h3>Количество назначений</h3>
                </div>
                <div className='boxMain'>
                    {loading ? <Loading type='inline' /> 
                    : warning ? <WarningPanel text={warning} buttonText='Обновить' buttonAction={() => setReload(true)} /> 
                    : 
                    <>
                    <p style={{fontSize: '14px'}}>Общее количество выборов кандидатуры СРО: {formInfo.count_all_submissions}</p>
                    <p style={{fontSize: '14px'}}>Количество утверждений АС: {formInfo.count_all_appointments}</p>
                    </>}
                </div>
                <div className='boxBottom'></div>
            </div>
        </>
    )
}

export default NumberOfAppointments;